const transformData = [
    {name: 'Very Low', value: 1},
    {name: '2', value: 2},
    {name: '3', value: 3},
    {name: '4', value: 4},
    {name: '5', value: 5},
    {name: '6', value: 6},
    {name: 'Very High', value: 7},
];

/**
 * question: How much have you improved your business model during the program on a scale of 1 (very low) to 7 (very high)?
 * == final
 * biz_mod_improved_t1
 * 
 * @param props 
 * @returns 
 */
export const businessModelImprovementChartCalculation = (props: any) => {
    const data = transformData.map(({name, value}) => ({
        name,
        y: props.finalSubmissions.filter((submission: any) => +submission.biz_mod_improved_t1 === value).length
    }));

    return {
        chart: {
            type: 'column',
        },
        title: {
            align: 'left',
            text: '',
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        xAxis: {
            categories: transformData.map((el) => el.name),
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
        series: [
            {
                showInLegend: false,
                name: 'Number',
                data: data,
                type: 'column',
                dataLabels: {
                    enabled: true,
                },
            },
        ],
    } as Highcharts.Options;
}